import TransactionTableData from "./TransactionTableData";
import Pagination from "components/Pagination";
import TableSkeleton from "./TableSkeleton";

const Table = ({
  data,
  th,
  getTransactions,
  page,
  numOfPages,
  setPage,
  loading,
}: any) => {
  // Show skeleton when loading
  if (loading) {
    return (
      <div className="tab-content">
        <div
          className="tab-pane fade show active"
          id="contactsListPane"
          role="tabpanel"
          aria-labelledby="contactsListTab"
        >
          <div className="card">
            <TableSkeleton columns={th?.length || 9} rows={5} />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="tab-content">
      <div
        className="tab-pane fade show active"
        id="contactsListPane"
        role="tabpanel"
        aria-labelledby="contactsListTab"
      >
        <div
          className="card"
          data-list='{"valueNames": ["item-name", "item-title", "item-email", "item-phone", "item-score", "item-company"], "page": 10, "pagination": {"paginationClass": "list-pagination"}}'
          id="contactsList"
        >
          {data?.length !== 0 ? (
            <div className="table-responsive">
              <table className="table table-sm table-hover table-nowrap card-table no-last-row-border">
                <thead>
                  <tr>
                    {th?.map((h: string, i: number) => {
                      return (
                        <th key={i} className="py-3 px-2">
                          <a
                            className="list-sort text-muted fw-600 font-onest capitalize"
                            data-sort={`item-${h}`}
                            href="#!"
                          >
                            {h}
                          </a>
                        </th>
                      );
                    })}
                  </tr>
                </thead>

                <TransactionTableData
                  getTransactions={getTransactions}
                  data={data}
                />
              </table>
              {/* Pagination inside the table box, right-aligned */}
              <div className="d-flex justify-content-end px-4 py-3">
                <Pagination
                  page={page}
                  numOfPages={numOfPages}
                  setPage={setPage}
                />
              </div>
            </div>
          ) : (
            <p className="py-4 text-center text-muted fs-14">
              No Recent Transactions
            </p>
          )}
        </div>
      </div>
    </div>
  );
};
export default Table;
